import { ShieldAlert } from 'lucide-react'
import type { RiskSeverity } from '../types'
import { RiskGroup } from './risk-group'

export interface EvaluationRisksProps {
  risks: {
    label: string
    severity: RiskSeverity
    detail: string
  }[]
}

export function EvaluationRisks({ risks }: EvaluationRisksProps) {
  return (
    <div className="mt-8">
      <div className="mb-3 flex items-center gap-3">
        <ShieldAlert className="size-4 text-red-400" />
        <h2 className="text-sm font-semibold text-foreground">Risks & Open Questions</h2>
      </div>
      <div className="space-y-3">
        {(['critical', 'high', 'moderate'] as const).map((severity) => {
          const group = risks.filter((r) => r.severity === severity)
          if (group.length === 0) return null
          return <RiskGroup key={severity} severity={severity} risks={group} />
        })}
      </div>
    </div>
  )
}
